module.exports = __webpack_public_path__ + "static/media/KW.032b4560.png";